import {
  NavigationBar,
  type NavigationBarIconName,
} from '@retailer-platform/shared-components/src/tds'
import { type ComponentType } from 'react'

// L1 icon factories follow this pattern: outline glyph at rest, filled glyph
// when the L1 is the active section (own URL match for leaf L1s, any descendant
// match for expandable L1s). The active flag is supplied by `TdsNavigationBar`
// at render time. Use this helper instead of inlining the factory so the
// resting/active distinction stays uniform across all L1s.
export const tdsNavIcon =
  (name: NavigationBarIconName) =>
  ({ isActive }: { isActive?: boolean }) => (
    <NavigationBar.Icon name={name} variant={isActive ? 'filled' : 'outline'} />
  )

// Same outline/filled pattern as `tdsNavIcon`, but for glyphs that the TDS
// NavigationBar icon set doesn't expose. Pass the filled + outline component
// pair from `@instacart/ids-core` and the wrapper matches NavigationBar.Icon's
// sizing (24px) and `currentColor` fill so the result slots into the same row
// layout as a TDS icon.
type IdsIconComponent = ComponentType<{ size?: string; fill?: string }>
export const tdsNavIconFromIds =
  (FilledIcon: IdsIconComponent, OutlineIcon: IdsIconComponent) =>
  ({ isActive }: { isActive?: boolean }) => {
    const Icon = isActive ? FilledIcon : OutlineIcon
    return (
      <span style={{ display: 'inline-flex' }}>
        <Icon size="24px" fill="currentColor" />
      </span>
    )
  }
